<ng-container *ngIf="!(isLoading$ | async) && (isEnabled$ | async) && (isAuthenticated$ | async)">
  <div class="top-banner" [ngClass]="feature$.level.toLowerCase()">
    <p>
      {{ message$ }}
    </p>
  </div>
</ng-container>
